export const MENU_SECTION_ENUM = {
  BEFORE_START: "before-start",
  CONSIDER: "consider",
  DESIGN: "design",
};
